import { AnalyticsEvent } from '../../analytics.event';

export class ApiErrorEvent extends AnalyticsEvent {
    constructor(
        endpoint: string,
        statusCode: number,
        request: Record<string, unknown>,
        response: Record<string, unknown>
    ) {
        super('api_error', {
            endpoint: endpoint,
            status_code: statusCode,
            request: request,
            response: response
        });
    }
}
